import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import {connect, useSelector} from "react-redux";
import BaseSidebar from "react-sidebar";
import classNames from "classnames";

import {
    getFilterOpened,
    setFilterOpened,
    SIDEBAR_CLASSNAME,
    setFilterClosing,
    getFilterClosing, getFilteredTransports,
} from "../../store/filterSlice";

import { getConfigButton, getMediaSize } from "../../store/configSlice";

import { SidebarContent } from "./SidebarContent";
import styles from "./Sidebar.module.scss";
import { MEDIA_SIZES } from "../../util/useMediaQuery";

function SidebarBody({
    filterOpened,
    setFilterOpened,
    size,
    filterClosing,
    setFilterClosing,
}) {


    const closeCallback = useCallback(() => {
        setFilterOpened(false);
        setFilterClosing(true);

        setTimeout(() => {
            setFilterClosing(false);
        }, 300);
    }, [setFilterOpened, setFilterClosing]);

    const sidebarContent = React.useMemo(() => {
        if (filterOpened || filterClosing) {
            return <>
                <SidebarContent close={closeCallback} />
            </>
        }
        else return <div></div>
    }, [filterOpened, filterClosing])


    return (
        <BaseSidebar
            sidebarClassName={classNames(SIDEBAR_CLASSNAME, styles.sidebar)}
            overlayClassName={styles.overlay}
            contentClassName={
                size !== MEDIA_SIZES.smartphone
                    ? size === MEDIA_SIZES.tablet
                        ? styles.buttonWrapper_tablet
                        : styles.buttonWrapper
                    : styles.buttonWrapper_mobile
            }
            sidebar={sidebarContent}
            open={filterOpened}
            onSetOpen={closeCallback}
        >
            <></>
        </BaseSidebar>
    );
}

SidebarBody.propTypes = {
    filterOpened: PropTypes.bool.isRequired,
    filterClosing: PropTypes.bool.isRequired,
    setFilterOpened: PropTypes.func.isRequired,
    buttonConfig: PropTypes.object,
    size: PropTypes.string,
};

const Sidebar = connect(
    (state) => ({
        filterOpened: getFilterOpened(state),
        buttonConfig: getConfigButton(state),
        size: getMediaSize(state),
        filterClosing: getFilterClosing(state),
    }),
    {
        setFilterOpened,
        setFilterClosing,
    }
)(SidebarBody);

Sidebar.propTypes = {};

export { Sidebar };
